import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Requests() {
  const [requests, setRequests] = useState<any[]>([]);
  const [form, setForm] = useState({ title: '', artist: '', notes: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const tenant = JSON.parse(localStorage.getItem('customer_tenant') || '{}');
  const color = tenant.color || '#7C3AED';

  const fetchRequests = async () => {
    try {
      const { data } = await api.get('/api/customer/songs/requests');
      setRequests(data.requests);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchRequests(); }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/api/customer/songs/requests', form);
      setMsg('✅ Petición enviada. El administrador la revisará.');
      setForm({ title: '', artist: '', notes: '' });
      fetchRequests();
    } catch (err: any) {
      setMsg('❌ ' + (err.response?.data?.error || 'Error'));
    } finally { setSaving(false); }
  };

  const statusLabel: Record<string, string> = {
    pending: '⏳ Pendiente',
    reviewed: '👀 Revisada',
    added: '✅ Agregada',
    rejected: '❌ No disponible',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', color: '#fff', fontFamily: 'sans-serif', padding: '1.5rem' }}>
      <h2 style={{ margin: '0 0 1.5rem' }}>🎵 Pedir canción</h2>

      <div style={{ background: '#1a1a2e', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', border: '1px solid #2a2a3e' }}>
        <p style={{ color: '#888', fontSize: '0.9rem', margin: '0 0 1rem' }}>¿No encuentras tu canción favorita? Pídela aquí y la agregaremos al catálogo.</p>
        <form onSubmit={handleSubmit}>
          <input style={inp} placeholder="Título de la canción *" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} required />
          <input style={inp} placeholder="Artista" value={form.artist} onChange={e => setForm(f => ({ ...f, artist: e.target.value }))} />
          <textarea style={{ ...inp, height: '80px', resize: 'none' as const }} placeholder="Notas adicionales (versión, año, etc.)" value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} />
          {msg && <p style={{ color: msg.startsWith('✅') ? '#10b981' : '#ef4444', fontSize: '0.9rem', margin: '0 0 0.75rem' }}>{msg}</p>}
          <button type="submit" disabled={saving} style={{ width: '100%', padding: '0.75rem', background: color, border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
            {saving ? 'Enviando...' : '📩 Enviar petición'}
          </button>
        </form>
      </div>

      <h3 style={{ margin: '0 0 1rem', color: '#888', fontSize: '1rem' }}>Mis peticiones ({requests.length})</h3>
      {requests.length === 0 ? (
        <p style={{ color: '#555', textAlign: 'center', padding: '2rem' }}>Aún no has hecho peticiones</p>
      ) : requests.map(r => (
        <div key={r.id} style={{ background: '#1a1a2e', borderRadius: '10px', padding: '1rem', marginBottom: '0.5rem', border: '1px solid #2a2a3e' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 600 }}>{r.title}</div>
              {r.artist && <div style={{ color: '#888', fontSize: '0.85rem' }}>{r.artist}</div>}
              {r.notes && <div style={{ color: '#666', fontSize: '0.8rem', marginTop: '0.25rem' }}>{r.notes}</div>}
            </div>
            <span style={{ fontSize: '0.78rem', background: r.status === 'added' ? '#064e3b' : r.status === 'rejected' ? '#7f1d1d' : '#2a2a3e', padding: '3px 8px', borderRadius: '99px', flexShrink: 0 }}>
              {statusLabel[r.status] || r.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

const inp: React.CSSProperties = { width: '100%', padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#0f0f1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '0.95rem', boxSizing: 'border-box' };
